<template>
  <!--数量-->
  <div class="item-cols-num clearfix">
    <div class="select" :style="{background:backColor}">
      <!-- 邻接间隙的默认参数是负数 -->
      <!-- <span class="down" @click.stop.prevent="down()" :class="{'down-disabled':Num <= 0}">-</span> -->
      <span class="down" @click.stop.prevent="down()">-</span>
      <span class="num">
        <input class="select-input" type="text" :class="{show:show}" v-model="Num" @blur="blur()" maxlength="5">
        <ul ref="ul">
          <li v-for="i in numList" :key="i">{{i}}</li>
        </ul>
        <div class="unit" :style="unitSize=='01'?'font-size:14px':''">{{unit}}</div>
      </span>
      <span class="up" :class="{'up-disabled':Num >= limit}" @click.stop.prevent="up()">+</span>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      num: {
        type: [Number],
        default: 1.00
      },
      step: {
        type: [Number],
        default: 0.1
      },
      limit: {
        type: Number,
        default: 100
      },
      unit: {
        type: String,
        default: 'mm'
      },
      backColor:{
        type:String,
        default:'#f7f7f7'
      },
      unitSize:{
        type:String,
        default:'00'
      },
      field:{
        type:String,
        default:''
      }
    },
    computed: {},
    data() {
      return {
        show: true,
        flag: true,
        Num: parseFloat(Number(this.num)).toFixed(3),
        Step: parseFloat(Number(this.step)).toFixed(3),
        numList: []
      }
    },
    methods: {
      up() {
        if (this.flag && this.Num < this.limit) {
          this.ani('up')
        }
        return false
      },
      down() {
        // if (this.flag && this.Num > 0) {
          this.ani('down')
        // }
        // return false
      },
      blur() {
        this.Num = this.Num > this.limit ? parseFloat(Number(this.limit)).toFixed(3) : parseFloat(Number(this.Num))
        .toFixed(3)
        this.$forceUpdate()
        // this.$emit('edit-num',this.field,this.Num)
        this.$emit('edit-num',this.Num)
      },
      ani(opera) {
        this.flag = false
        let n = Number(this.Num)
        this.numList = [parseFloat(n - Number(this.Step)).toFixed(3), n, parseFloat(n + Number(this.Step)).toFixed(3)]
        let ul = this.$refs.ul
        let ulStyle = ul.style
        this.show = false
        ulStyle.zIndex = '99'
        ulStyle.transition = 'all .2s ease-out'
        if (opera === 'up') {
          this.Num = parseFloat(Number(this.Num) + Number(this.Step)).toFixed(3);
          ulStyle.transform = 'translateY(-54px)'
        } else {
          this.Num = parseFloat(Number(this.Num) - Number(this.Step)).toFixed(3);
          ulStyle.transform = `translateY(-18px)`
        }

        ul.addEventListener('transitionend', () => {
          this.show = true
          this.domInt(ulStyle)
          this.flag = true
        })

        ul.addEventListener('webkitAnimationEnd', () => {
          this.show = true
          this.domInt(ulStyle)
          this.flag = true
        })
        this.$emit('edit-num',this.Num)
      },
      domInt(domStyle) {
        domStyle.zIndex = '1'
        domStyle.transition = 'all 0s'
        domStyle.transform = 'translateY(-36px)' // 回到原位
      }
    }
  }
</script>
<style lang="scss" scoped>
  .select {

    .select-input {
      z-index: 10;
      width: 36px;
      height: 32px;
      border: none;
      text-align: center;
      line-height: 18px;
      font-size: 13px;
      padding: 0;
      color: #666;
      visibility: hidden;
      position: relative;
      border: none;
      background: #FFFFFF;

      &.show {
        visibility: visible;
      }
    }

    ul {
      padding: 0;
      line-height: 18px;
      font-size: 13px;
      display: inline-block;
      position: absolute;
      left: 0;
      list-style: none;
      width: 60px;
      font-family: system-ui;
      z-index: 1;
      transform: translateY(-36px);
    }

    .up.up-disabled,
    .up.up-disabled:hover {
      background-position: 0 -240px !important;
      cursor: not-allowed !important;
    }
  }

  /*数量*/
  .item-cols-num {
    display: inline-block;
  }

  .select {
    padding: 3px;
    border-radius: 4px;
    height: 40px;
    // background: #f7f7f7;

    .select-input {
      width: 100%;
      text-align: center;
    }

    .down {
      background-position: 0 -60px;
    }

    .down.down-disabled:hover {
      background-position: 0 -300px;
      cursor: not-allowed;
    }

    .down,
    .up {
      background: url(../../static/images/cart-updown_8303731e15@2x.jpg) no-repeat;
      overflow: hidden;
      float: left;
      width: 34px;
      height: 34px;
      background-size: 100% auto;
      line-height: 40px;
      text-indent: -9999em;
      cursor: pointer;
      user-select: none;
    }

    .num {
      position: relative;
      overflow: hidden;
      text-align: center;
      float: left;
      width: 100px;
      height: 32px;
      border: none;
      border-radius: 4px;
      line-height: 18px;
      text-align: center;
      font-size: 13px;
      display: flex;
      flex-direction: row;
      align-items: center;
      background: #FFFFFF;
      margin: 0 5px;
      border: 1px solid #DCDFE6;

      &:hover {
        border: 1px solid #20a0ff;
      }

    }

    .unit {
      font-size: 16px;
      line-height: 32px;
      padding: 0 5px 3px;
      width: 60px;
    }

    .up {
      margin: 0;
      background-position: 0 0;
      border-radius: 50%;

      &:hover {
        background-position: 0 -120px;
      }
    }

    .down {
      background-position: 0 -60px;
      border-radius: 50%;

      &:hover {
        background-position: 0 -180px;
      }
    }
  }

  .down.down-disabled {
    background-position: 0 -300px;
    cursor: not-allowed;
  }
</style>



// WEBPACK FOOTER //
// inputNum.vue?cede5456